module.exports = __webpack_public_path__ + "static/img/university-logo_V0.1-06.7ab46aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/genestesting/university-logo_V0.1-06.png
// module id = nGJ0
// module chunks = 0